import React from "react";
import PropTypes from "prop-types";
import { ProductsProvider } from "./ProductsProvider";
import ProductsGrid from "./ProductsGrid";
import CardsColumn from "./Cards/CardsColumn";
import FilterGroups from "./Filters/FilterGroups";

const ProductsIndex = ({ lang, cta, cta2 }) => {
	
	return (
		<ProductsProvider 
			language={lang}
			cta={JSON.parse(cta)}
			cta2={JSON.parse(cta2)}
		>
			<ProductsGrid>
				<FilterGroups />
				<CardsColumn />
			</ProductsGrid>
		</ProductsProvider>
	);
}

ProductsIndex.propTypes = {
	lang: PropTypes.string,
	cta: PropTypes.string,
	cta2: PropTypes.string,
};


export default ProductsIndex;